module.exports = __webpack_public_path__ + "img/Brc_Banner.2dad5d1e.png";